import React, { useState } from 'react';
import AuthLayout from './AuthLayout';
import { userServices } from '../APIServices/userServices';

function LoginPage({ onLogin, onSwitchToSignup, onSwitchToForgot }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const loginAdmin = async (e) => {
    e.preventDefault();
    setLoading(true);
    const userData = {
      email,
      password,
      roleData: ["user"],
    };
    await userServices.login(userData);
    setLoading(false);
  };

  return (
    <AuthLayout
      title="Welcome Back"
      subtitle="Sign in to access your clinical operations dashboard"
    >
      <form className="auth-form" onSubmit={loginAdmin}>
        {error && (
          <div className="auth-message error">
            <i className="ti ti-alert-circle" />
            {error}
          </div>
        )}

        <div className="field">
          <label>Email Address</label>
          <div className="input-with-icon">
            <i className="ti ti-mail" />
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="demo@arcolab.com"
              required
            />
          </div>
        </div>

        <div className="field">
          <label>Password</label>
          <div className="input-with-icon">
            <i className="ti ti-lock" />
            <input
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
            />
            <button
              type="button"
              className="toggle-password"
              onClick={() => setShowPassword(!showPassword)}
            >
              <i className={showPassword ? 'ti ti-eye-off' : 'ti ti-eye'} />
            </button>
          </div>
        </div>

        <div className="auth-options">
          <label>
          </label>
          <button
            type="button"
            className="auth-link"
            onClick={onSwitchToForgot}
          >
            Forgot password?
          </button>
        </div>

        <button type="submit" className="auth-btn" 
        disabled={loading}
        >
          {loading ? (
            <>
              <i className="ti ti-loader-2" style={{ animation: 'spin 1s linear infinite' }} />
              Signing in...
            </>
          ) : (
            'Sign In'
          )}
        </button>
      </form>
    </AuthLayout>
  );
}

export default LoginPage;